import { Tooltip, Typography } from "@mui/material";

interface Props {
  reason: string;
  label: string;
}

export const ReasoningTooltip: React.FC<Props> = ({ reason, label }) => {
  return (
    <Tooltip
      title={<Typography variant="body2">{reason}</Typography>}
      placement="top"
      slotProps={{
        popper: { sx: { zIndex: 99999 } },
        tooltip: {
          sx: {
            bgcolor: "white",
            boxShadow: 1,
            "& .MuiTooltip-arrow": {
              color: "white",
            },
            width: "auto",
          },
        },
      }}
    >
      <span>{label}</span>
    </Tooltip>
  );
};
